import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["auth"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React, { memo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { AuthProvider } from "@jutro/auth";
import { SecureRoute } from "@jutro/router";
var missingAuthCode = {
    errorCode: "missing_auth"
  },
  AuthRouteInternal = function (_ref) {
    var path = _ref.path,
      renderBody = _ref.render,
      AuthErrorComponent = _ref.authErrorComponent,
      _ref$authComponent = _ref.authComponent,
      ProviderComponent = void 0 === _ref$authComponent ? AuthProvider : _ref$authComponent,
      history = useHistory(),
      onLocationChange = useCallback(function (newPath) {
        return history.replace(newPath);
      }, [history]),
      render = useCallback(function (_ref2) {
        var auth = _ref2.auth,
          routeProps = _objectWithoutProperties(_ref2, _excluded);
        return auth ? auth.error ? React.createElement(AuthErrorComponent, {
          error: auth.error
        }) : renderBody(function (e) {
          for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
              _defineProperty(e, r, t[r]);
            }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
              _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
            });
          }
          return e;
        }({
          isAuthenticated: auth.isAuthenticated
        }, routeProps)) : React.createElement(AuthErrorComponent, {
          error: missingAuthCode
        });
      }, [AuthErrorComponent, renderBody]);
    return React.createElement(ProviderComponent, {
      authErrorComponent: AuthErrorComponent,
      onLocationChange: onLocationChange
    }, React.createElement(SecureRoute, {
      path: path,
      render: render
    }));
  };
AuthRouteInternal.displayName = "AuthRoute";
export var AuthRoute = memo(AuthRouteInternal);
AuthRouteInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AuthRoute",
  props: {
    authComponent: {
      defaultValue: {
        value: "AuthProvider",
        computed: !0
      },
      required: !1
    }
  }
}, AuthRouteInternal.__docgenInfo = {
  componentName: "AuthRoute",
  packageName: "@jutro/app",
  description: "",
  displayName: "AuthRoute",
  methods: [],
  actualName: "AuthRouteInternal",
  props: {
    authComponent: {
      defaultValue: {
        value: "AuthProvider",
        computed: !0
      },
      required: !1
    }
  }
};